
(function passwordStrengthModuleDefinition() {

    'use strict';

    angular.module('PasswordStrength', []);

})();